import palette from "../palette";

export default {
	root: {
		color: palette.black,
		backgroundColor: palette.white,
	},
};
